var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "domain" },
    [
      _c(
        "navigation-bar",
        [
          _c("navigation-link", {
            attrs: {
              icon: "icon_search",
              label: "Workflows",
              to: {
                name: "workflow-list",
                params: { clusterName: _vm.clusterName }
              }
            }
          }),
          _vm._v(" "),
          _c("navigation-link", {
            attrs: {
              label: "Settings",
              icon: "icon_settings",
              to: {
                name: "domain-settings",
                params: { clusterName: _vm.clusterName }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "feature-flag",
            { attrs: { display: "inline", name: "domainMetrics" } },
            [
              _c("navigation-link", {
                attrs: {
                  label: "Metrics",
                  icon: "icon_chart",
                  to: {
                    name: "domain-metrics",
                    params: { clusterName: _vm.clusterName }
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("navigation-link", {
            attrs: {
              label: "Archival",
              icon: "icon_trip-history",
              to: {
                name: "workflow-archival",
                params: { clusterName: _vm.clusterName }
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "workflow-list",
          "cluster-name": _vm.clusterName,
          "date-format": _vm.dateFormat,
          domain: _vm.domain,
          "time-format": _vm.timeFormat,
          timezone: _vm.timezone
        }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "domain-settings",
          "cluster-name": _vm.clusterName,
          domain: _vm.domain
        }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "domain-metrics",
          "cluster-name": _vm.clusterName,
          domain: _vm.domain
        }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: {
          name: "workflow-archival",
          "cluster-name": _vm.clusterName,
          "date-format": _vm.dateFormat,
          domain: _vm.domain,
          "time-format": _vm.timeFormat,
          timezone: _vm.timezone
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cba21394", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cba21394","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/domain/index.vue
// module id = 1700
// module chunks = 0